import createReducer from "../lib/createReducer";
import * as types from "../actions/types";

const a = {};
export const dataUserOpeningTimeslot = createReducer(a, {
  [types.USER_OPENING_TIMESLOT](state, action) {
    let newState = a;
    newState = { ...action.value };
    return newState;
  }
});
